import type { ReactNode } from 'react';

import { Icon } from '@/shared/ui/atoms/Icon';
import './FilterChip.styl';

type Props = { label: ReactNode; active?: boolean; onClick?: () => void; caret?: boolean };

export function FilterChip({ label, active = false, onClick, caret = true }: Props) {
  return (
    <button type="button" className={active ? 'm-chip m-chip--active' : 'm-chip'} onClick={onClick} aria-pressed={active}>
      <span>{label}</span>
      {caret ? <Icon name="chevronDown" size={12} strokeWidth={2} /> : null}
    </button>
  );
}
